import React, { Component } from "react";
import { Helmet } from "react-helmet";

import { APPLICATION_STATUSES } from "../../utils/consts";
import { UserContext } from "../../Context";
import LoggedOutContent from "../../components/LoggedOutContent/LoggedOutContent";
import Loading from "../../components/loading/Loading";
import ProfileForm from "../../components/profileForm/ProfileForm";
// import ApplyCard from "../../components/applyCard/ApplyCard";

import "./profile.css";
// import AppliedCard from "../../components/AppliedCard/AppliedCard";
import ProfileAppliedCard from "../../components/ProfileAppliedCard/ProfileAppliedCard";
export default class Profile extends Component {
  render() {
    // console.log(this.props);
    return (
      <UserContext.Consumer>
        {userContext => {
          // console.log(userContext);
          return (
            <div className="profile padded-body">
              <Helmet>
                <title>{`Profile`}</title>
                <meta name="description" content={userContext.displayName} />
              </Helmet>
              {(userContext.userLoading || userContext.myLoading) && (
                <div className="profile-loading full-body-content">
                  <Loading />
                </div>
              )}
              {!userContext.userLoading &&
                userContext.user &&
                !userContext.myLoading && (
                  <div className="profile-container">
                    <ProfileForm {...this.props} />
                  </div>
                )}
              {!userContext.userLoading &&
                !!userContext.user &&
                !userContext.applicationLoading &&
                !userContext.myLoading &&
                userContext.application &&
                userContext.application.status &&
                userContext.application.status ===
                  APPLICATION_STATUSES._INCOMPLETE && (
                  <div
                    style={{
                      position: "fixed",
                      display: "flex",
                      bottom: "-20px",
                      right: "20px"
                    }}
                    className="profile-application"
                  >
                    <ProfileAppliedCard
                      addFlag={userContext.addFlag}
                      my={userContext.my}
                      lid={userContext.application.lid}
                    />
                  </div>
                )}
              {!userContext.userLoading && !userContext.user && (
                <LoggedOutContent />
              )}
            </div>
          );
        }}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/Profile.js